import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterContentInit,
  Component,
  HostListener,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  HostBinding,
  ViewEncapsulation,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';

import { PressKit } from '@modules/content-api/adapter/press-kit.adapter';
import { ButtonItem, ActionContainerComponent } from '@modules/ui/action-container/action-container.component';
import { MetaItemInterface, MetaItemsComponent } from '@modules/ui/meta-items/meta-items.component';

import { ArticleModel } from '../models/article.model';

@Component({
  selector: 'mb-article-status-bar',
  templateUrl: 'article-status-bar.component.html',
  styleUrls: ['article-status-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('visibilityChanged', [
      state(
        'false',
        style({
          transform: 'translateY(100%)',
          visibility: 'hidden',
        })
      ),
      state(
        'true',
        style({
          transform: 'translateY(-0%)',
          visibility: 'visible',
        })
      ),
      transition('0 => 1', animate('0.3s ease-out')),
      transition('1 => 0', animate('0.3s ease-in')),
    ]),
  ],
  imports: [MetaItemsComponent, ActionContainerComponent],
})
export class ArticleStatusBarComponent implements OnInit, AfterContentInit {
  private platformId = inject(PLATFORM_ID);
  @HostBinding('class.visible')
  visible = false;

  // aricle which is shared in the displayed sharing hub
  // displayed title
  @Input() article!: ArticleModel | PressKit;
  @Input()
  public title!: string;

  @Input()
  buttonItems: ButtonItem[] = [];

  @Output() actionClick = new EventEmitter();
  @Output() metaItemClicked = new EventEmitter<MetaItemInterface>();

  @Input() images: number = 4;
  @Input() videos: number = 2;
  @Input() audios: number = 4;
  @Input() documents!: number;
  @Input() technicalDatas!: number;

  @Input() metaItems: MetaItemInterface[] = [];

  private _progress = 0;
  get progress(): number {
    return this._progress;
  }
  set progress(value: number) {
    this._progress = Math.min(Math.max(value, 0), 1);
    this.visible = this._progress > 0.1 && this._progress < 1;
  }

  public areMetaItemsEmpty!: boolean;

  ngOnInit(): void {
    this.areMetaItemsEmpty = this.metaItems.every((metaItem) => metaItem.count === 0);
  }

  ngAfterContentInit(): void {
    // initally trigger check for visibility
    this.onScroll();
  }

  @HostListener('window:scroll')
  onScroll(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // calculate how many of the page has been scrolled right now and
    // adjust the progress bar width to show the progress
    const pageHeight: number = document.body.scrollHeight - window.innerHeight;
    const footerHeight = 520;
    const articleHeight = pageHeight - footerHeight;
    this.progress = pageYOffset / articleHeight;
  }
}
